import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-color-div',
  templateUrl: './color-div.component.html',
  styleUrls: ['./color-div.component.scss']
})
export class ColorDivComponent {
  @Input()
  public colorString!: string;
}
